module.exports = __webpack_public_path__ + "img/dev2.b54527b9.png";